/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { useState } from 'react';
import PropTypes from "prop-types";
import { EuiAccordion } from '../accordion';
import { useGeneratedHtmlId } from '../../services';
import { useEuiI18n } from '../i18n';
import { EuiText } from '../text';
export var EuiNotificationEventMessages = ({
  messages,
  eventName
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const messagesLength = messages.length;
  const accordionId = useGeneratedHtmlId({
    prefix: 'euiNotificationEventMessagesAccordion'
  });
  const accordionButtonText = useEuiI18n('euiNotificationEventMessages.accordionButtonText', '+ {messagesLength} more', {
    messagesLength: messagesLength - 1
  });
  const accordionAriaLabelButtonText = useEuiI18n('euiNotificationEventMessages.accordionAriaLabelButtonText', '+ {messagesLength} messages for {eventName}', {
    messagesLength: messagesLength - 1,
    eventName
  });
  const accordionHideText = useEuiI18n('euiNotificationEventMessages.accordionHideText', 'hide');
  const buttonContentText = isOpen ? `${accordionButtonText} (${accordionHideText})` : accordionButtonText;
  return <div className="euiNotificationEventMessages">
      {messages && messagesLength === 1 ? <EuiText size="s" color="subdued">
          <p>{messages}</p>
        </EuiText> : <>
          <EuiText size="s" color="subdued">
            <p>{messages[0]}</p>
          </EuiText>

          <EuiAccordion onToggle={setIsOpen} buttonProps={{
        'aria-label': accordionAriaLabelButtonText
      }} id={accordionId} className="euiNotificationEventMessages__accordion" buttonContent={buttonContentText} buttonClassName="euiNotificationEventMessages__accordionButton" arrowDisplay="none">
            <div className="euiNotificationEventMessages__accordionContent">
              {messages.map((notification, index) => <EuiText size="s" key={index} color="subdued">
                    <p>{notification}</p>
                  </EuiText>).slice(1)}
            </div>
          </EuiAccordion>
        </>}
    </div>;
};
EuiNotificationEventMessages.propTypes = {
  /*
     * An array of strings that get individually wrapped in `<p>` tags
     */
  messages: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  /**
     * A unique, human-friendly name for the event to be used in aria attributes (e.g. "alert-critical-01", "cloud-no-severity-12", etc..).
     */
  eventName: PropTypes.string.isRequired
};
try {
  EuiNotificationEventMessages.__docgenInfo = {
    tags: {},
    filePath: '/Users/briannahall/Documents/EUI/eui/src/components/notification/notification_event_messages.tsx',
    description: '',
    displayName: 'EuiNotificationEventMessages',
    methods: [],
    props: {
      messages: {
        defaultValue: null,
        description: '',
        name: 'messages',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/notification/notification_event_messages.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string[]'
        }
      },
      eventName: {
        defaultValue: null,
        description: 'A unique, human-friendly name for the event to be used in aria attributes (e.g. "alert-critical-01", "cloud-no-severity-12", etc..).',
        name: 'eventName',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/notification/notification_event_messages.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}